
        import { LOCAL_DEV_DEBUG } from './config/local_dev.ts';

        const debugInfoEl = document.getElementById('debugInfo');
        const fpsCounterEl = document.getElementById('fpsCounter');
        const fpsValueEl = document.getElementById('fpsValue');
        const debugContentEl = document.getElementById('debugContent');

        function isDebugEnabled() {
            if (!LOCAL_DEV_DEBUG.enabled) {
                return false;
            }

            if (!LOCAL_DEV_DEBUG.requireDebugParam) {
                return true;
            }

            const value = new URLSearchParams(window.location.search).get(LOCAL_DEV_DEBUG.paramName);
            return value === 'true';
        }

        function setOverlayPosition(element, position) {
            if (!element) {
                return;
            }

            element.classList.remove(
                'overlay-pos-top-left',
                'overlay-pos-top-right',
                'overlay-pos-bottom-left',
                'overlay-pos-bottom-right'
            );

            element.classList.add(`overlay-pos-${position}`);
        }

        // Initialize loading screen hide after 2 seconds
        // (will be hidden when scene is ready)
        setTimeout(() => {
            const loadingScreen = document.getElementById('loadingScreen');
            if (loadingScreen && !loadingScreen.classList.contains('hidden')) {
                console.log('[index.html] Scene took longer than 2 seconds, hiding loading screen automatically');
                loadingScreen.classList.add('hidden');
            }
        }, 2000);

        const debugEnabled = isDebugEnabled();
        document.body.classList.toggle('debug-enabled', debugEnabled);

        if (debugInfoEl) {
            setOverlayPosition(debugInfoEl, LOCAL_DEV_DEBUG.overlays.stats.position);
            if (!LOCAL_DEV_DEBUG.overlays.stats.enabled) {
                debugInfoEl.style.display = 'none';
            }
        }

        if (fpsCounterEl) {
            setOverlayPosition(fpsCounterEl, LOCAL_DEV_DEBUG.overlays.fps.position);
            if (!LOCAL_DEV_DEBUG.overlays.fps.enabled) {
                fpsCounterEl.style.display = 'none';
            }
        }

        if (!debugEnabled) {
            if (debugInfoEl) debugInfoEl.style.display = 'none';
            if (fpsCounterEl) fpsCounterEl.style.display = 'none';
        }

        // Simple FPS counter
        let frameCount = 0;
        let lastTime = performance.now();
        function updateFPS() {
            if (!debugEnabled || !LOCAL_DEV_DEBUG.overlays.fps.enabled || !fpsValueEl) {
                return;
            }
            frameCount++;
            const currentTime = performance.now();
            if (currentTime - lastTime >= 1000) {
                fpsValueEl.textContent = String(frameCount);
                frameCount = 0;
                lastTime = currentTime;
            }
            requestAnimationFrame(updateFPS);
        }
        if (debugEnabled && LOCAL_DEV_DEBUG.overlays.fps.enabled) {
            updateFPS();
        }

        // Update debug info
        function updateDebugInfo() {
            if (!debugEnabled || !LOCAL_DEV_DEBUG.overlays.stats.enabled || !debugContentEl) {
                return;
            }

            const babylon = (window).__babylon;
            if (babylon) {
                const engine = babylon.engine?.();
                const scene = babylon.scene?.();
                if (engine && scene) {
                    const lines = [];
                    if (LOCAL_DEV_DEBUG.overlays.stats.fields.engine) {
                        const className =
                            typeof engine.getClassName === 'function'
                                ? engine.getClassName()
                                : engine.constructor?.name;
                        let engineLabel = 'WebGL 1';
                        if (className === 'WebGPUEngine') {
                            engineLabel = 'WebGPU';
                        } else if (engine.webGLVersion === 2) {
                            engineLabel = 'WebGL 2';
                        }
                        lines.push(`<div>Engine: ${engineLabel}</div>`);
                    }
                    if (LOCAL_DEV_DEBUG.overlays.stats.fields.meshes) {
                        lines.push(`<div>Meshes: ${scene.meshes.length}</div>`);
                    }
                    if (LOCAL_DEV_DEBUG.overlays.stats.fields.lights) {
                        lines.push(`<div>Lights: ${scene.lights.length}</div>`);
                    }
                    if (LOCAL_DEV_DEBUG.overlays.stats.fields.cameras) {
                        lines.push(`<div>Cameras: ${scene.cameras.length}</div>`);
                    }
                    if (LOCAL_DEV_DEBUG.overlays.stats.fields.materials) {
                        lines.push(`<div>Materials: ${scene.materials.length}</div>`);
                    }
                    debugContentEl.innerHTML = lines.join('');
                }
            }
            requestAnimationFrame(updateDebugInfo);
        }
        if (debugEnabled && LOCAL_DEV_DEBUG.overlays.stats.enabled) {
            updateDebugInfo();
        }

        // Hide loading screen when scene is ready
        function hideLoadingScreen() {
            const loadingScreen = document.getElementById('loadingScreen');
            if (loadingScreen && !loadingScreen.classList.contains('hidden')) {
                console.log('[index.html] Scene ready, hiding loading screen');
                loadingScreen.classList.add('hidden');
            }
        }

        // Hook into Babylon scene ready event
        setInterval(() => {
            const babylon = (window).__babylon;
            if (babylon && babylon.scene?.()) {
                hideLoadingScreen();
            }
        }, 100);
    